import { useQuery } from '@tanstack/react-query'
import API from '../services'

export type PriceTable = {
  first_monthly: number
  first_yearly: number
  first_extra: number
  second_monthly: number
  second_yearly: number
  second_extra: number
  third_monthly: number
  third_yearly: number
  third_extra: number
}

const fetchPrices = async (): Promise<PriceTable> => {
  const response = await fetch(API.url + 'getPrices')
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return response.json()
}

export const usePrices = () => {
  return useQuery({
    queryKey: ['prices'],
    queryFn: fetchPrices,
  })
}
